import { Link } from 'react-router-dom';

const employeeAssessment = [
  'что сотрудник умеет сейчас',
  'какие компетенции развиты',
  'какие есть зоны развития',
  'какой потенциал у сотрудника',
  'что ему необходимо развивать',
];

export default function AssessmentVsTrainingEval() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Чем оценка сотрудников отличается от оценки обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Оценка сотрудников и оценка эффективности обучения — это не одно и то же.
        </p>

        <div className="grid lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl border border-teal-200 p-6 md:p-8">
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-4">Оценка сотрудников</h3>
            <p className="text-sm text-teal-700 font-semibold mb-4">Определяет потребность в развитии</p>
            <ul className="space-y-2.5">
              {employeeAssessment.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-gray-700 leading-relaxed">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-4">Оценка эффективности обучения</h3>
            <p className="text-sm text-gray-500 font-semibold mb-4">Определяет результат уже проведённого обучения</p>
            <p className="text-sm text-gray-700 leading-relaxed mb-4">
              Отвечает на другой вопрос: изменилось ли что-то после проведённого обучения? То есть — закрепились ли новые знания, навыки и поведение в работе.
            </p>
            <Link
              to="/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
            >
              Оценка эффективности обучения персонала
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}